var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home no-padding-top"},[_c('div',{ref:"gtmNoScript"}),_c('Loading',{attrs:{"loading":_vm.load}}),_c('router-view'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }